export const HIERARCHICAL_CHILDREN_PROP_NAME = "Children";
export const HIERARCHICAL_PARENT_PROP_NAME = "Parent";